import * as React from "react";
import TodayEventsCard from "./TodayEventsCard";
import moment from 'moment';

const TodayEventsCardList = ({events, startDate, setEventToSee, setTabValue, setScreenNumberDefault}) => {
    const eventsList = (events) => {
        const oldEvents = events.old ? events.old:[];
        const newEvents = events.new ? events.new:[];
        const nowEvents = events.now ? events.now:[];
        return [...oldEvents, ...newEvents, ...nowEvents];
    }
    const list = eventsList(events);
    const checkDate = (theEvent) => {
        console.log(startDate)
        console.log(moment(theEvent.start_date * 1000))
        console.log(moment(startDate))
        //moment(startDate).isBetween(moment(theEvent.start_date * 1000), moment(theEvent.end_date * 1000))
        return moment(startDate).isBetween(moment(theEvent.start_date * 1000), moment(theEvent.end_date * 1000),'day', '[]');

    }
    return list && list.length > 0 ?
        list.map((event) => (
             checkDate(event) &&
             <TodayEventsCard
                 event={event}
                 setTabValue={setTabValue}
                 setEventToSee={setEventToSee}
                 setScreenNumberDefault={setScreenNumberDefault}
             >
             </TodayEventsCard>
        )):''
}

export default TodayEventsCardList;
